import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureFlagService } from '@app/services/feature-flag.service';
import { LocalStorageService } from '@app/services/local-storage.service';
import { LocaleService } from '@app/services/locale.service';
import { ContentService } from 'app-classic/services/content.service';
import { UserAccountService } from 'app-classic/services/user-account.service';
import { ConfirmationComponent as NewConfirmationComponent } from '../../../app/components/confirmation/confirmation.component';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    standalone: false,
})
export class ConfirmationComponent extends NewConfirmationComponent {
    constructor(
        private _localStorageService: LocalStorageService,
        private _router: Router,
        private _localeService: LocaleService,
        private _featureFlagService: FeatureFlagService,
        private _userAccountService: UserAccountService,
        private _contentService: ContentService
    ) {
        super(_localStorageService, _router, _localeService, _featureFlagService, _userAccountService, _contentService);
    }
}
